import store_patient from "@/store/mods/clinique/patients"

export default {
    name: 'choix-patient',
    components: {},
    props: [],
    data() {
        return {
            list_patients: [],
            patient_is_loading: true,
            patient_is_empty: false,
            is_load_error: false,

            patient_filter: "",
            perPage: 200,
            currentPage: 1,
            fields: [
                { key: 'patient', label: 'Patients' }, { key: 'sexe', label: 'Sexes' }, { key: 'age', label: 'Âge' },
                { key: 'telephone', label: 'Téléphones' }, 'assurance', 'action.s'
            ],
        }
    },

    computed: {
    },

    mounted() {
        this.getListePatients()
    },

    methods: {
        getListePatients() {
            this.is_load_error = false
            this.patient_is_loading = true
            store_patient.getListeAllPatient().then((patients) => {
                this.list_patients = patients
                if (this.list_patients.length > 0) {
                    this.patient_is_empty = false
                } else {
                    this.patient_is_empty = true
                }
    
                this.patient_is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.patient_is_loading = false
            })
        },

        setSelectedPatient(patient_data) {
            const selected_patient = {
                patient_id: parseInt(patient_data.patient_id),
                nom: patient_data.patient_nom,
                prenoms: "",
                nom_patient: patient_data.patient_nom,
                sexe: patient_data.sexe,
                telephone_mobile: patient_data.patient_telephone,
                age: patient_data.age,
                num_dossier: patient_data.patient_code
            }
            this.$emit('emitSelectedPatient', selected_patient)
        }
    }
}